import { NgModule } from '@angular/core'
import { FullTeaserSplitFeatureModule } from './full-teaser-split/full-teaser-split-feature.module'
import { TeaserBigFeatureModule } from './teaser-big/teaser-big-feature.module'
import { TeaserBigVideoFeatureModule } from './teaser-big-video/teaser-big-video-feature.module'
import { TeaserBoxesHomepageFeatureModule } from './teaser-boxes-homepage/teaser-boxes-homepage-feature.module'
import { TeaserBoxesIconFeatureModule } from './teaser-boxes-icon/teaser-boxes-icon-feature.module'
import { TeaserBoxesMediaFeatureModule } from './teaser-boxes-media/teaser-boxes-media-feature.module'
import { TopicTeaserBoxFeatureModule } from './topic-teaser-box/topic-teaser-box-feature.module'
import { TeaserSliderContainerFeatureModule } from './teaser-slider-container/teaser-slider-container-feature.module'

@NgModule({
  imports: [
    FullTeaserSplitFeatureModule,
    TeaserBigFeatureModule,
    TeaserBigVideoFeatureModule,
    TeaserBoxesHomepageFeatureModule,
    TeaserBoxesIconFeatureModule,
    TeaserBoxesMediaFeatureModule,
    TopicTeaserBoxFeatureModule,
    TeaserSliderContainerFeatureModule
  ]
})
export class TeaserRootModule {}
